import { render, staticRenderFns } from "./NotificationTemplateSettings.vue?vue&type=template&id=7c4ebf7e&scoped=true"
import script from "./NotificationTemplateSettings.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplateSettings.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTemplateSettings.vue?vue&type=style&index=0&id=7c4ebf7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4ebf7e",
  null
  
)

export default component.exports